<template>
  <div class="fadeIn">
    <div class="ra-auth--form__header">
      <h6>Recover account</h6>
      <p>We'd send a recovery code to your email.</p>
    </div>
    <div class="ra-auth--form__form">
      <el-form :model="form" label-position="top" ref="form" @submit.prevent>
        <el-row type="flex" class="flex-wrap">
          <el-col :span="24">
            <el-form-item
              label="Email"
              prop="identifier"
              :rules="validateEmail('Email')"
            >
              <el-input type="email" v-model="form.identifier" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="ra-auth--form__actions">
      <el-button :loading="sending" type="primary" @click="requestForOtp"
        >Send</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
      sending: false,
      form: {
        identifier: ""
      }
    };
  },

  methods: {
    requestForOtp() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.sending = true;
        this.$http
          .post("auth/local/users/forgot", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.sending = false;
              this.handleErrors(resData);
            } else {
              sessionStorage.setItem(
                "radius-verification-data",
                JSON.stringify({
                  ...resData,
                  email: this.form.identifier
                })
              );
              this.notification(
                "OTP Sent",
                "An OTP has been sent to your email for verification",
                "success"
              );
              this.$router.push({ name: "verify-otp" });
            }
          })
          .catch(() => {
            this.sending = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    }
  }
};
</script>
